import { toNumber } from "utility/Common";
import React from "react";
import NumberFormat from "react-number-format";

export default function NumberInputDecimal({
  name = "",
  onChange = () => {},
  value = undefined,
  disabled = false,
  className = "",
  onKeyDown = () => {},
  autoFocus = false,
  decimalScale = 2,
  ...props
}) {
  const classes = ["form-control"];
  if (className) classes.push(className);
  return (
    <NumberFormat
      name={name}
      className={classes.join(" ")}
      thousandSeparator={"."}
      decimalSeparator={","}
      decimalScale={decimalScale}
      disabled={disabled}
      value={value}
      onKeyDown={onKeyDown}
      autoFocus={autoFocus}
      onChange={(e) => {
        let value = null;
        if (e.target.value) {
          value = toNumber(e.target.value);
        }

        onChange({
          ...e,
          target: {
            ...e.target,
            name,
            value,
          },
        });
      }}
      {...props}
    />
  );
}
